import React, { Component } from 'react';
import Thumbnail from '../Lightbox/Thumbnail';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { uniq, xorBy } from 'lodash';
import ItineraryBG from '../../images/itineraryBG.png';
import Clock from '../../images/icons/clock.png';
import PlayButton from '../../images/icons/PlayButt.png';
import scrollIcon from '../../images/icons/scroll_gif.gif';

class NewItinerary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDay: 0,
      showScrollBar: false
    };
    this.onSelectDay = this.onSelectDay.bind(this);
  }

  componentDidMount(){
    this.onSelectDay(0);
  }

  onSelectDay(index){
    this.setState({selectedDay: index});
    this.itineraryItemGroup.scrollTo({top: 0, behavior: 'auto'});
    setTimeout(() => {
      if (this.itineraryItemGroup){
        let newScrollableCheck = false;
        newScrollableCheck = this.itineraryItemGroup.scrollHeight > this.itineraryItemGroup.clientHeight;
        this.setState({showScrollBar: newScrollableCheck});
      }
    },500);
  }

  render() {
    const {
      itinerary,
      theme,
      sidePhotos,
      galleryPrefix,
      t,
      byorSelected,
      togglePopUpVideo
    } = this.props;

    // const uniqueDays = uniq(itinerary.map(activity => activity.day_no));
    // const itDays = uniqueDays[0] === null ? ['1'] : uniqueDays;

    return (
      <section className='fe-trip-new-itinerary'>
        <div className='container'>
          <div className='fe-trip-itinerary-box'>
            <div className='fe-trip-itinerary-left'>
              <h4 className='fe-trip-main-heading'>{t('trip:itinerary')}</h4>
              <div className='fe-trip-itinerary-menu'>
                {itinerary.map((day, x) => (
                  <div key={x} className={`fe-trip-itinerary-menu-day ${(this.state.selectedDay === x) ? 'selected' : null}`} onClick={() => this.onSelectDay(x)}>
                    Day {(x !== null) ? (x+1) : 1}
                  </div>
                ))}
              </div>
            </div>

            <div className='fe-trip-itinerary-right'>
              <div className='fe-trip-itinerary-tentatif'>

                <div className='fe-trip-itinerary-timeline-box'>
                  <img src={Clock} className='fe-trip-itinerary-timeline-icon'/>
                  <div className={`fe-trip-itinerary-timeline ${(this.state.showScrollBar) ? 'scrollable' : ''}`}>
                  </div>
                  {(this.state.showScrollBar) ? (
                    <img src={scrollIcon} className='fe-trip-itinerary-scroll-icon'/>
                  ) : null}
                </div>

                <div className='fe-trip-itinerary-item-group' ref={itineraryItemGroup => (this.itineraryItemGroup = itineraryItemGroup)}>
                  <div className='fe-trip-itinerary-activity-group'>
                    {itinerary[this.state.selectedDay].map((activity, x) => (
                      <div key={x} className='fe-trip-itinerary-item'>
                        <div className='fe-trip-itinerary-time'>
                          {activity.time}
                        </div>
                        <div className='fe-trip-itinerary-activity'>
                          {activity.activity}
                          {activity.sub_text ? (
                            <p
                              className='fe-trip-it-subtext'
                              dangerouslySetInnerHTML={{
                                __html: activity.sub_text
                              }}
                            />
                          ) : null}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className='fe-trip-itinerary-gallery-group'>
                    {itinerary[this.state.selectedDay].map((activity, x) => (
                      (activity.images.length) ? (
                        <>
                        <div key={x} className='fe-trip-itinerary-gallery-wrap'>
                          {activity.images.map((image, y) =>(
                            (y < 2) ? (
                              (activity.images.length === 1) ? (
                                <div className={`fe-trip-itinerary-gallery-inner-wrap ${(activity.images.length > 1) ? 'half' : 'full'}`}>
                                  <figure key={(image.image_id) ? image.image_id : image.id} className='half'>
                                    <div className='fe-u-thumb-4by3'>
                                      {(image.youtubeUrl) ? (
                                        <div
                                          className='fe-video-overlay-play'
                                        >
                                          <button className='fe-play-button' onClick={() => togglePopUpVideo(true, image.youtubeUrl)}>
                                            <img src={PlayButton}/>
                                          </button>
                                        </div>
                                      ) : null}
                                      <Thumbnail
                                        // id={y}
                                        id={0}
                                        // galleryId={`${galleryPrefix}-itinerary-${x}`}
                                        galleryId={`${galleryPrefix}-itinerary-1`}
                                        // src={'https://shop.sdacford.com.my/images/trips/njcjfc3i5.jpeg'}
                                        // fullSrc={'https://shop.sdacford.com.my/images/trips/njcjfc3i5.jpeg'}
                                        src={image.img_url}
                                        fullSrc={image.img_url}
                                        alt=''
                                        // isFinalImage={y + 1 >= activity.images.length}
                                      />
                                    </div>
                                    <figcaption></figcaption>
                                  </figure>
                                </div>
                              ) : (
                                (y === 1) ? (
                                  <div className={`fe-trip-itinerary-gallery-inner-wrap ${(activity.images.length > 2) ? 'half' : 'full'}`}>
                                    <figure key={(activity.images[y-1].image_id) ? activity.images[y-1].image_id : activity.images[y-1].id} className='half'>
                                      <div className='fe-u-thumb-4by3'>
                                        {(activity.images[y-1].youtubeUrl) ? (
                                          <div
                                            className='fe-video-overlay-play'
                                          >
                                            <button className='fe-play-button' onClick={() => togglePopUpVideo(true, activity.images[y-1].youtubeUrl)}>
                                              <img src={PlayButton}/>
                                            </button>
                                          </div>
                                        ) : null}
                                        <Thumbnail
                                          // id={y-1}
                                          id={0}
                                          // galleryId={`${galleryPrefix}-itinerary-${x}`}
                                          galleryId={`${galleryPrefix}-itinerary-2`}
                                          src={activity.images[y-1].img_url}
                                          fullSrc={activity.images[y-1].img_url}
                                          alt=''
                                          // isFinalImage={(y-1) + 1 >= activity.images.length}
                                        />
                                      </div>
                                      <figcaption></figcaption>
                                    </figure>
                                    <figure key={(image.image_id) ? image.image_id : image.id} className='half'>
                                      <div className='fe-u-thumb-4by3'>
                                        {(image.youtubeUrl) ? (
                                          <div
                                            className='fe-video-overlay-play'
                                          >
                                            <button className='fe-play-button' onClick={() => togglePopUpVideo(true, image.youtubeUrl)}>
                                              <img src={PlayButton}/>
                                            </button>
                                          </div>
                                        ) : null}
                                        <Thumbnail
                                          // id={y}
                                          id={0}
                                          // galleryId={`${galleryPrefix}-itinerary-${x}`}
                                          galleryId={`${galleryPrefix}-itinerary-3`}
                                          src={image.img_url}
                                          fullSrc={image.img_url}
                                          alt=''
                                          // isFinalImage={y + 1 >= activity.images.length}
                                        />
                                      </div>
                                      <figcaption></figcaption>
                                    </figure>
                                  </div>
                                ) : null
                              )
                            ) : (
                              <div className='fe-trip-itinerary-gallery-inner-wrap half'>
                                <figure key={(image.image_id) ? image.image_id : image.id} className='full'>
                                  <div className='fe-u-thumb-4by3'>
                                    {(image.youtubeUrl) ? (
                                      <div
                                        className='fe-video-overlay-play'
                                      >
                                        <button className='fe-play-button' onClick={() => togglePopUpVideo(true, image.youtubeUrl)}>
                                          <img src={PlayButton}/>
                                        </button>
                                      </div>
                                    ) : null}
                                    <Thumbnail
                                      // id={y}
                                      id={0}
                                      // galleryId={`${galleryPrefix}-itinerary-${x}`}
                                      galleryId={`${galleryPrefix}-itinerary-4`}
                                      src={image.img_url}
                                      fullSrc={image.img_url}
                                      alt=''
                                      // isFinalImage={y + 1 >= activity.images.length}
                                    />
                                  </div>
                                  <figcaption></figcaption>
                                </figure>
                              </div>
                            )
                          ))}
                        </div>
                        </>
                      ) : null
                    ))}
                  </div>

                </div>

              </div>

            </div>
          </div>
        </div>
      </section>
    );
  }
}

NewItinerary.propTypes = {
  itinerary: PropTypes.array.isRequired,
  theme: PropTypes.string.isRequired,
  sidePhotos: PropTypes.array.isRequired,
  galleryPrefix: PropTypes.string.isRequired,
  togglePopUpVideo: PropTypes.func,
  t: PropTypes.func.isRequired
};

NewItinerary.defaultProps = {
  galleryPrefix: ''
};

export default withTranslation()(NewItinerary);
